import React ,{useState} from 'react';
import contact from '../../assets/img/contact.png';
import CommonHeader from '../../Components/CommonHeader/common-header.component';
import { useForm } from "react-hook-form";
import { sendContactData } from '../../api/auth';
import toast from 'react-hot-toast'
import Footer from '../../Components/Footer/footer.component'
import { useTranslation } from 'react-i18next';



function Contact() {
    const { register, handleSubmit, formState: { errors },reset } = useForm();
    const [loading,setLoading]=useState(false)
    const onSubmit = async(data) => {
        setLoading(true)
        try {
            const res=await sendContactData(data)
            toast.success(res.message, {
                style: {
                    fontFamily: 'Montserrat',
                    },
            })
            reset()
        } catch (error) {
            toast.error("Une erreur s'est produite", {
				style: {
					fontFamily: 'Montserrat',
				},
			});
        }finally{
            setLoading(false)
        }
    };
    const {t} = useTranslation();

    return (
        <div>
            <CommonHeader />
            <div style={{
                backgroundColor: '#f8f9fa', 
                paddingBottom:'4rem',
                paddingTop:'4rem'
            }}>
            <div style={{ 
                display: 'flex',
                justifyContent: 'center',
            }}>
                {/* Section globale avec bordure */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        overflow: 'hidden',
                        border: '1px solid #ddd',
                        maxWidth: '900px',
                        width: '100%',
                        fontFamily:'Montserrat' ,

                    }}
                >
                    {/* Image sur la gauche */}
                    <div
                      style={{
                        position: 'relative',
                        flex: 1.5, // Augmenter la proportion de l'image
                        backgroundColor: '#f0f0f0',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    >
                        {/* Superposition transparente */}
                        <div
                            style={{
                                position: 'absolute', 
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(0, 0, 0, 0.3)', 
                                zIndex: 1, 
                            }}
                        ></div>

                        {/* Image */}
                        <img
                            src={contact}
                            alt="Delivery worker"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                maxWidth: '800px',
                                objectFit: 'cover',
                                borderRight: '1px solid #ddd',
                                position: 'relative', 
                                zIndex: 0, 
                            }}
                        />
                    </div>

                    {/* Formulaire sur la droite */}
                    <div style={{ flex: 2, padding: '2rem' }}>
                        <h2
                            style={{
                                marginBottom: '1rem',
                                fontSize: '1.8rem',
                                color: '#333',
                                textAlign: 'center',
                            }}
                        >
                            {t("contact_us")}
                        </h2>
                        <p
                            style={{
                                marginBottom: '2rem',
                                fontSize: '1rem',
                                color: '#666',
                                textAlign: 'center',
                            }}
                        >
                            {t("contact_us_paragraph")}
                        </p>
                        <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                           
                        <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold',fontSize: 15,color:"#333"}}>
                                    {t("contact_us_formulair_item1")}
                                </label>
                                <input
                                    type="text"
                                    placeholder={t("contact_us_formulair_item1")}
                                    {...register("fullName", { required: t("contact_us_formulair_item1_err")})}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        borderWidth:1
                                    }}
                                />
                                {errors.fullName && <span style={{ color: 'red', fontSize: '0.9rem' }}>{errors.fullName.message}</span>}
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold',fontSize: 15,color:"#333"}}>
                                    {t("email")}
                                </label>
                                <input
                                    type="email"
                                    placeholder={t("email")}
                                    {...register("email", {
                                        required: t("err_message1")+ t("email"),
                                        pattern: {
                                            value: /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/,
                                            message: t("email_err_message"),
                                        },
                                    })}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        border: '1px solid  #ccc',
                                        borderRadius: '4px',
                                        borderWidth:1
                                    }}
                                />
                                {errors.email && <span style={{ color: 'red', fontSize: '0.9rem' }}>{errors.email.message}</span>}
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' ,fontSize: 15,color:"#333"}}>
                                    {t("contact_us_formulair_item2")}
                                </label>
                                <input
                                    type="tel"
                                    placeholder={t("contact_us_formulair_item2")}
                                    {...register("phone", {
                                        required: t("phone_number_err1"),
                                    })}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        border: '1px solid   #ccc',
                                        borderRadius: '4px',
                                        borderWidth:1
                                    }}
                                />
                                {errors.phone && <span style={{ color: 'red', fontSize: '0.9rem' }}>{errors.phone.message}</span>}
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold',fontSize: 15,color:"#333"}}>
                                   {t("contact_us_formulair_item3")}
                                </label>
                                <input
                                    type="text"
                                    placeholder={t("contact_us_formulair_item3")}
                                    {...register("subject", { required: t("contact_us_formulair_item3_err") })}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        borderWidth:1
                                    }}
                                />
                                {errors.subject && <span style={{ color: 'red', fontSize: '0.9rem' }}>{errors.subject.message}</span>}
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' ,fontSize: 15,color:"#333"}}>
                                    Message
                                </label>
                                <textarea
                                    placeholder="Message"
                                    {...register("message", { required: t("contact_us_formulair_item4_err") })}
                                    style={{
                                        width: '100%',
                                        padding: '0.5rem',
                                        border: '1px solid  #ccc',
                                        borderRadius: '4px',
                                        minHeight: '100px',
                                        borderWidth:1
                                    }}
                                />
                                {errors.message && <span style={{ color: 'red', fontSize: '0.9rem' }}>{errors.message.message}</span>}
                            </div>


                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    padding: '0.75rem',
                                    background:'#51C7F2',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    padding: '1rem 4rem',
	                                fontWeight: 'bold'
                                }}
                            >
                                {t("submit_button")} 
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Contact;
